export default __webpack_public_path__ + "static/media/arrow-up-right-blue.7b9fe01b.svg";